import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { ArrowDownIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative w-full min-h-screen bg-bg-primary flex items-center justify-center overflow-hidden" data-id="element-67">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-bg-primary via-bg-secondary to-bg-primary opacity-50" data-id="element-68" />

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20" data-id="element-69">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-70">
          {/* Left column - Copy */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8
        }} className="space-y-8" data-id="element-71">
            <motion.h1 className="font-heading text-5xl sm:text-6xl lg:text-7xl leading-tight text-text-primary" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2,
            duration: 0.6
          }} data-id="element-72">
              El músculo es el nuevo{' '}
              <span className="text-accent-bronze" data-id="element-73">fondo de jubilación</span>
            </motion.h1>

            <motion.p className="text-xl sm:text-2xl text-text-secondary font-body leading-relaxed" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.4,
            duration: 0.6
          }} data-id="element-74">
              Cómo invertir en tu cuerpo hoy para no depender de nadie mañana.
              El protocolo científico de fuerza para argentinos +35 que no
              tienen tiempo de perder.
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.6,
            duration: 0.6
          }} className="flex flex-col sm:flex-row items-start sm:items-center gap-6" data-id="element-75">
              <CTAButton size="large" onClick={() => {
              const finalCTA = document.getElementById('final-cta');
              finalCTA?.scrollIntoView({
                behavior: 'smooth'
              });
            }} data-id="element-76">
                Acceder al Protocolo Completo
              </CTAButton>

              <div className="flex flex-col" data-id="element-77">
                <span className="text-text-muted text-sm font-body" data-id="element-78">
                  Inversión única
                </span>
                <span className="text-accent-gold text-3xl font-heading" data-id="element-79">
                  $10.500 ARS
                </span>
                <span className="text-text-muted text-sm font-body" data-id="element-80">
                  El precio de una cena afuera
                </span>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            delay: 1,
            duration: 0.6
          }} className="flex items-center gap-3 text-text-secondary text-sm" data-id="element-81">
              <div className="flex -space-x-2" data-id="element-82">
                <div className="w-8 h-8 rounded-full bg-accent-bronze border-2 border-bg-primary" data-id="element-83" />
                <div className="w-8 h-8 rounded-full bg-accent-gold border-2 border-bg-primary" data-id="element-84" />
                <div className="w-8 h-8 rounded-full bg-accent-bronze border-2 border-bg-primary" data-id="element-85" />
              </div>
              <span data-id="element-86">+2.400 argentinos ya blindaron su futuro</span>
            </motion.div>
          </motion.div>

          {/* Right column - Product image */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.3
        }} className="relative" data-id="element-87">
            <motion.div animate={{
            y: [0, -10, 0]
          }} transition={{
            duration: 3,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="relative z-10" data-id="element-88">
              <img src="https://cdn.magicpatterns.com/uploads/vSKV2psfkEF4DNmLFiSaXV/heylloyd-image-1771777616302.png" alt="Código Longevidad: Fuerza Progresiva - Ebook en tablet" className="w-full max-w-lg mx-auto drop-shadow-2xl" data-id="element-89" />
            </motion.div>

            {/* Decorative glow */}
            <div className="absolute inset-0 bg-accent-bronze opacity-20 blur-3xl -z-10" data-id="element-90" />
          </motion.div>
        </div>

        {/* Scroll indicator */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1.5,
        duration: 0.6
      }} className="absolute bottom-10 left-1/2 transform -translate-x-1/2 flex flex-col items-center gap-2" data-id="element-91">
          <span className="text-text-muted text-sm font-body" data-id="element-92">
            Descubrí por qué
          </span>
          <motion.div animate={{
          y: [0, 10, 0]
        }} transition={{
          duration: 1.5,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-93">
            <ArrowDownIcon className="w-6 h-6 text-accent-bronze" data-id="element-94" />
          </motion.div>
        </motion.div>
      </div>
    </section>;
}